import * as React from "react";

import { DrawerView } from "../../Common";

import { DrawerFragment_Delivery_ViewModel } from "./drawer-fragment-delivery-view-model";
import { DrawerFragment_Delivery_Content } from "./drawer-content-delivery";

export const DrawerFragment_Delivery: React.FunctionComponent = (props) => {
  return (
    <React.Fragment>
      <DrawerView useDrawerViewModel={DrawerFragment_Delivery_ViewModel}>
        <DrawerFragment_Delivery_Content />
      </DrawerView>
    </React.Fragment>
  );
};
